import { BoxAutor } from "./styles";
import ContentPayWallExclusive from "../ContentPayWallExclusive";

const ContentAuthor = ({ author, authorSignature, payWallExclusive, section, showSectionOrAuthorName = true, alwaysShowSectionName = false }) => {

    const sectionName = (Array.isArray(section) && section.length && typeof section[0].name !== 'undefined') 
        ? section[0].name.replace("Recetas -", "")
        : "";
    const authorName = authorSignature ? authorSignature : author?.[0]?.name;
    const nameClass = authorSignature ? authorSignature : (author?.[0]?.name ? "name-author" : "name-section" );
    return (
        <>
        <BoxAutor className="data-txt " showPipe={authorName && payWallExclusive}>
            {
                payWallExclusive && <div className="ifPaywallPipe"><ContentPayWallExclusive /></div> 
            }
            {authorName == "" && payWallExclusive ? 
                <p className={`name ${nameClass}`}>REDACCIÓN CLARÍN</p>
            :
                <p className={`name ${nameClass}`}>
                    {alwaysShowSectionName 
                        ? sectionName 
                        : (showSectionOrAuthorName ? (authorName || sectionName) : authorName)}
                </p>
            }
        </BoxAutor>
        </> 
    );
}

export default ContentAuthor;


